// Vue mixin för generisk widget:

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';


// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//------------------------------------------------------------------------------------------------------------------------------

const mixin = {

	mixins: [ euiLifecycleStatusesMixin ],

	props: {
		vpWidgetId: {
			type: String,
			required: true,
		},

		vpWidgetElementName: {
			type: String,
			required: true,
		},

		vpWidgetOriginalElementName: {
			type: String,
			required: false,
		},

		vpWidgetParameters: {
			type: String,
			required: true,
		},

		vpWidgetMonth: {
			type: String,
			required: false,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpWidgetSettings', i de fall widgeten i sig sjäv kan komma att ändra dess värde (ex ändra diagraminställningar):
		vpWidgetSettings: {
			type: Object,
			required: true,
		},

		vpWidgetData: {
			type: Object,
			required: true,
		},

		vpArIRedigeralage: {
			type: Boolean,
			required: false,
			default: false,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpMenyConfig':
		vpMenyConfig: {	// null/undefined = saknas
			type: [euiPopUpMenyClasses.menyConfig],	//, Object],
			default: null,
		},

		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},

		//modalcontainer: {			// Placeholder (div) på sidan där det går att injicera modala "dialogrutor"
		//	type: HTMLDivElement,
		//	required: false,
		//},
		//pages: {						// Sidor som det går att flytta widgeten till
		//	type: Array,
		//	required: true,
		//},
	},

	data() {
		return {
			uniktId: 'eui-gen-widget-unikt-' + (++uniktIdCounter),
			menyConfig: this.vpMenyConfig,

			// Hm.. arIAndralage är existensberättigad *endast* för att kunna kommunicera *från* mixin-koden till konsumerande komponent (eventet som styr hanteras i denna mixin):
			arIAndralage: false,
		};
	},

	computed: {
		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedHasOccured);
		},
		skaVaraInaktiverad() {
			return (this.vpInaktiverad || !this.lifecycleStatuses.mixinMountedHasOccured);
		},
	},

	watch: {
		vpMenyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				this.menyConfig = nyttVarde;
			},
			deep: true,
		},

		menyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				// Propen används med .sync i parent component:
				this.$emit('update:vpMenyConfig', nyttVarde);
			},
			deep: true,
		},
	},

	methods: {
		onMenyalternativValtIPanel({ eventId, eventData }) {

			this.$emit('menyalternativ-valt-i-widget',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);

			// Operationen Ändra ska hanteras av widgetkomponenten själv:
			if (eventId === 'andraWidget')
			{
				// Försätt widgeten i ändraläge:
				this.arIAndralage = true;
			}
		},
	},

};

export { mixin as ssoGeneriskWidgetMixin };

